import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import {
    TextField,
    MenuItem,
    Button,
    Card,
    CardContent,
    Typography,
    IconButton,
    Box,
    Grid,
    TextareaAutosize,
    Autocomplete,
} from "@mui/material";
import styled from "@emotion/styled";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';
import { useState } from "react";
import dayjs from 'dayjs';
import { selectTipologiaIntervento, selectIsLoading, selectStatoIntervento } from "../../../features/manutenzione/manutenzioneSlice";
import { createManutenzioneData, updateManutenzioneData, fetchTipologiaIntervano, singleManutenzione, fetchStatoIntervento } from "../../../features/manutenzione/manutenzioneThunk";
import 'dayjs/locale/it';
import { useDispatch, useSelector } from "react-redux";
dayjs.locale('it');

const schema = yup.object().shape({
    intervento: yup.string().required("Intervento è obbligatorio"),
    tipo_di_intervento: yup.string().required("Tipologia di intervento è obbligatoria"),
    dataIntervento: yup.date()
        .required("Data intervento è obbligatoria")
        .typeError("Inserisci una data valida"),
    km_mezzo: yup.number()
        .typeError("KM mezzo deve essere un numero")
        .required("KM mezzo all'intervento è obbligatorio")
        .positive("Il valore deve essere positivo")
        .integer("Il valore deve essere un numero intero"),
    stato_intervento: yup.string().required("Stato intervento è obbligatorio"),
});

const ManutenzioneForm = ({ cantine, setCantine, singleData, onClose }) => {
    const dispatch = useDispatch();
    const isLoading = useSelector(selectIsLoading);
    const tipologieIntervento = useSelector(selectTipologiaIntervento);
    const statoIntervento = useSelector(selectStatoIntervento);
    const [openSnackbar, setOpenSnackbar] = useState(false);

    // Set default values based on singleData if available
    const defaultValues = {
        intervento: "",
        tipo_di_intervento: null,
        dataIntervento: "",
        km_mezzo: "",
        stato_intervento: ""
    };

    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
        setValue
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: defaultValues
    });

    useEffect(() => {
        dispatch(fetchTipologiaIntervano());
        dispatch(fetchStatoIntervento());
    }, [dispatch]);

    // Set form values when singleData changes
    useEffect(() => {
        if (cantine) {
            setValue("intervento", singleData?.intervento || "");
            setValue("tipo_di_intervento", singleData?.tipo_di_intervento || null);
            setValue("dataIntervento", singleData?.data_intervento ? dayjs(singleData.data_intervento) : null);
            setValue("km_mezzo", singleData?.km_mezzo || "");
            setValue("stato_intervento", singleData?.stato_intervento || null);
        }
    }, [singleData, setValue]);

    const onSubmit = async(data) => {

        const formData = new FormData();
        // formData.append("id", data.id || 1);
        formData.append("company_id",  localStorage.getItem('company_id'));
        formData.append("mezzi_id",  localStorage.getItem('mezzi_id'));
        formData.append("intervento", data.intervento);
        formData.append("km_mezzo", data.km_mezzo);
        formData.append("data_intervento", data.dataIntervento ? dayjs(data.dataIntervento).format("YYYY-MM-DD") : null);
        formData.append("stato_intervento", data.stato_intervento);
        formData.append("tipo_di_intervento", data.tipo_di_intervento);
        const payload = {
            intervento: data.intervento,
            km_mezzo: data.km_mezzo,
            data_intervento: data.dataIntervento ? dayjs(data.dataIntervento).format("YYYY-MM-DD") : null,
            stato_intervento: data.stato_intervento,
            tipo_di_intervento: data.tipo_di_intervento
        }
        if (cantine) {
            const res =await dispatch(updateManutenzioneData({
                id: singleData.id,
                data: payload,
            })).unwrap()
            console.log("jjjjnature", res)
            if (res.success) {
                setCantine(false)
                localStorage.removeItem("manutenzione")
            }



        } else {
            // Create Mode
            dispatch(createManutenzioneData(formData))
                .unwrap()
                .then(() => {
                    setOpenSnackbar(true);
                    setCantine(false)
                    reset();
                })
                .catch((err) => {
                    console.error("Create Manutenzione Error:", err);
                });
        }
    };

    return (
        <>
            <form className="AziendaFrom" onSubmit={handleSubmit(onSubmit)}>
                <div className="AziendaFrom__inner">
                    <Controller
                        name="intervento"
                        control={control}
                        render={({ field }) => (
                            <TextField className="customTextBox"
                                {...field}
                                label="intervento"
                                fullWidth
                                margin="normal"
                                error={!!errors.intervento}
                                helperText={errors.intervento?.message}
                            />
                        )}
                    />

                    <Controller
                        name="tipo_di_intervento"
                        control={control}
                        render={({ field: { onChange, value, ...rest } }) => (
                            <Autocomplete
                                {...rest}
                                options={tipologieIntervento || []}
                                value={value}
                                onChange={(event, newValue) => onChange(newValue)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Tipologia di intervento (Meccanico, Carrozzeria, ecc.)"
                                        className="customTextBox autoCompleteTextBox"
                                        margin="normal"
                                        fullWidth
                                        error={!!errors.tipo_di_intervento}
                                        helperText={errors.tipo_di_intervento?.message}
                                    />
                                )}
                            />
                        )}
                    />

                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
                        <Controller
                            name="dataIntervento"
                            control={control}
                            render={({ field }) => (
                                <DatePicker
                                    label="Data Intervento"
                                    className='datePickerField'
                                    value={field.value ? dayjs(field.value) : null}
                                    onChange={(newValue) => field.onChange(newValue)}
                                />
                            )}
                        />
                    </LocalizationProvider>

                    <Controller
                        name="km_mezzo"
                        control={control}
                        render={({ field }) => (
                            <TextField className="customTextBox"
                                {...field}
                                label="KM mezzo all'intervento"
                                fullWidth
                                margin="normal"
                                error={!!errors.km_mezzo}
                                helperText={errors.km_mezzo?.message}
                            />
                        )}
                    />

                    <Controller
                        name="stato_intervento"
                        control={control}
                        render={({ field: { onChange, value, ...rest } }) => (
                            <Autocomplete
                                {...rest}
                                options={statoIntervento || []}
                                value={value}
                                onChange={(event, newValue) => onChange(newValue)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Stato Intervento"
                                        className="customTextBox autoCompleteTextBox"
                                        margin="normal"
                                        fullWidth
                                        error={!!errors.stato_intervento}
                                        helperText={errors.stato_intervento?.message}
                                    />
                                )}
                            />
                        )}
                    />

                    <div className="btnPart1">
                        <Button type="submit" variant="contained">
                            Salva dati
                        </Button>
                    </div>
                </div>
            </form>
        </>
    );
};

export default ManutenzioneForm;